var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#upload_svg__clip0)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#ED1B2E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.293 11.293a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L12 13.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 11a1 1 0 011 1v9a1 1 0 01-2 0v-9a1 1 0 011-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.663 2.009A9 9 0 0117.48 8H18a6.002 6.002 0 015.497 8.398 6 6 0 01-2.628 2.87 1 1 0 11-.958-1.756A4 4 0 0018 10H16.74a1 1 0 01-.968-.75 7 7 0 10-12.023 6.388 1 1 0 11-1.498 1.324A9 9 0 018.663 2.01z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.293 11.293a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L12 13.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "upload_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}

export default SvgUpload;